module.exports = __webpack_public_path__ + "static/media/st.daa7ecd9.svg";